// Enum StatusMesa
export const StatusMesa = {
  Livre: 0,
  Ocupada: 1,
  Reservada: 2,
  Limpeza: 3,
  Fechada: 4
};